import { connect } from "react-redux";
import { fetchDownloads } from "../store/actions/assignments";
import List from '../components/downloads/list';
import withAuth from '../hocs/withAuth';

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    workoutCats: state.workoutCats,
    workouts: state.workouts,
    programCats: state.programCats,
    programs: state.programs,
    groups: state.groups,
    clients: state.clients,
    assignments: state.assignments,
    partners: state.partners,
    brandDetails: state.brand.detail,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDownloads: (param) => {
      return dispatch(fetchDownloads(ownProps.user._id || localStorage.id, param));;
    }
  }
}

export const Donwloads = withAuth(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Donwloads.js